<app-header [forceLightBackground]="true"></app-header>
<div class="usecases-home">
  <div class="usecases-home--layout">
    <app-admin-sidebar class="usecases-home--sidebar"></app-admin-sidebar>
    <div class="usecases-home--content">
      <app-page-header></app-page-header>
      <div class="usecases-home--container">
        <app-stepper
          [steps]="steps"
          [currentStep]="currentStep"
          [disableNextButton]="currentStep === 0 && !validateGeneralInfo()"
          [disablePublishButton]="currentStep === 1 && !validateUsecaseInfo()"
          (stepChange)="onStepChange($event)"
          (next)="onNext()"
          (previous)="onPrevious()"
        ></app-stepper>
      </div>
    </div>
  </div>
</div>

<!-- Step Templates -->
<ng-template #generalInfoTemplate>
  <app-metadata-information
    [formData]="metadataFormData"
    [validationErrors]="validationErrors"
    (formDataChange)="onMetadataFormDataChange($event)"
    (validationErrorsChange)="onMetadataValidationErrorsChange($event)"
    (titleAvailabilityChange)="onTitleAvailabilityChange($event)"
  ></app-metadata-information>
</ng-template>

<ng-template #usecaseInfoTemplate>
  <app-usecase-information
    [metadata]="metadataFormData"
    [sections]="usecaseSections"
    (sectionsChange)="onUsecaseSectionsChange($event)"
    (parsedContentChange)="onUsecaseParsedContentChange($event)"
    (validationErrorsChange)="onUsecaseValidationErrorsChange($event)"
  ></app-usecase-information>
</ng-template>

<!-- Success Confirmation Modal -->
<app-confirmation-dialog
  [(visible)]="showSuccessModal"
  type="success"
  title="Success"
  message="You've now successfully created a Use Case"
  [showCancelButton]="true"
  confirmLabel="View Use Case"
  cancelLabel="Create new use case"
  themeColor="green"
  [width]="'540px'"
  (onConfirm)="onViewUsecase()"
  (onCancel)="onCreateNewUsecase()"
  (onClose)="onSuccessModalClose()"
></app-confirmation-dialog>
